"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeedbackReportClosed = exports.FEEDBACK_REPORT_COMMENT_MAX_LENGTH = exports.FEEDBACK_REPORT_PRIORITIES = exports.FEEDBACK_REPORT_CLOSED_STATUSES = exports.FEEDBACK_REPORT_STATUSES = void 0;
// Boards V2 beta feedback's lifecycle, shared by the callable and the Feedback admin page. The Firestore rules repeat these lists (feedbackReports in firestore.rules): keep
// them in step.
// In the order a report moves through them.
exports.FEEDBACK_REPORT_STATUSES = [
    'new',
    'triaged',
    'needs_info',
    'approved',
    'progress',
    'fixed',
    'merged',
    'deployed',
    'wontfix',
    'duplicate',
];
// A report in one of these is closed: nobody holds it, and closedAt says when it closed (moving
// between them keeps it). fixed (in a pull request), merged and deployed are its fix shipping;
// wontfix and duplicate close it without one. Nothing deletes it: the page's default view leaves it out.
exports.FEEDBACK_REPORT_CLOSED_STATUSES = ['fixed', 'merged', 'deployed', 'wontfix', 'duplicate'];
exports.FEEDBACK_REPORT_PRIORITIES = ['p0', 'p1', 'p2', 'p3'];
// A comment's body, and a status change's note, at most.
exports.FEEDBACK_REPORT_COMMENT_MAX_LENGTH = 4000;
const isFeedbackReportClosed = (status) => exports.FEEDBACK_REPORT_CLOSED_STATUSES.includes(status);
exports.isFeedbackReportClosed = isFeedbackReportClosed;
